export const OTP_ERROR = "OTP_ERROR";
export const OTP_SUCCESS = "OTP_SUCCESS";
export const OTP_LOADING = "OTP_LOADING";
export const OTP_REQ_SENT = "OTP_REQ_SENT";
export const OTP_REQ_FAILED = "OTP_REQ_FAILED";
export const OTP_VERIFYING = "OTP_VERIFYING";
export const OTP_VERIFIED = "OTP_VERIFIED";
export const OTP_VERIFICATION_FAILED = "OTP_VERIFICATION_FAILED";
export const OTP_RESET_MESSAGE = "OTP_RESET_MESSAGE";
